import { ConfigProvider } from "antd";
import Router from "./routers";
import './Tailwind.css';

// Màu & font đồng bộ với website (bảng màu nhận diện Viettel)
const ADMIN_THEME = {
  token: {
    colorPrimary: "#EE0033",
    colorLink: "#EE0033",
    colorLinkHover: "#B30000",
    colorText: "#1a1a1a",
    colorTextSecondary: "#44494D",
    colorBorder: "#D9D9D9",
    colorBgLayout: "#F2F2F2",
    fontFamily: "'Roboto', -apple-system, 'Segoe UI', sans-serif",
    borderRadius: 6,
  },
};

function App() {
  return (
    <ConfigProvider theme={ADMIN_THEME}>
      <Router />
    </ConfigProvider>
  );
}

export default App;
